var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInPersonMeet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.57,
    height: 20.992,
    viewBox: "0 0 14.57 20.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-139.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.816,0a7.293,7.293,0,0,0-7.285,7.285c0,3.867,6.609,12.9,6.891,13.283l.263.357a.163.163,0,0,0,.263,0l.262-.357c.282-.383,6.891-9.416,6.891-13.283A7.294,7.294,0,0,0,67.816,0Zm0,4.676a2.61,2.61,0,1,1-2.61,2.61A2.612,2.612,0,0,1,67.816,4.676Z",
    transform: "translate(79.379)",
    fill: "#e55cff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInPersonMeet);
export default __webpack_public_path__ + "static/media/in_person_meet.1407cd7285825f9ba25ef85b5a0b22d7.svg";
export { ForwardRef as ReactComponent };